import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionsPipe } from '../pipe/permissions.pipe';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(
    private router: Router,
    private permission_pipe: PermissionsPipe
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let module = route.data['permission'];
    let access = route.data['access'];
    if (!this.permission_pipe.transform(module, access)) {
      this.router.navigate(['unauthorised']);
      return false;
    }
    return true;
  }
}
